import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getWorkspaces } from 'Screens/Workspaces/actions/Actions';
import { MODAL_APPLY_TEMPLATE } from 'store/modals/modals';
import selectModal from 'store/modals/selectors';
import ApplyTemplateModal from 'Screens/KnowledgeBase/components/EditVuln';
import { resetState } from 'store/Manage/actions';
import { TableContainer } from './styled';
import VulnsContextMenu from './components/ContextMenu';
import BulkUpdateConfirmationDialog from './components/BulkUpdateConfirmationDialog';
import Table from './components/Table';
import BulkUpdateModal from './components/BulkUpdateModal';

const ManageTable = () => {
  const dispatch = useDispatch();
  const showTemplateModal = useSelector((state) => selectModal(state, MODAL_APPLY_TEMPLATE));

  useEffect(() => {
    dispatch(getWorkspaces());
    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);

  return (
    <TableContainer>
      {showTemplateModal && <ApplyTemplateModal />}
      <VulnsContextMenu />
      <BulkUpdateModal />
      <BulkUpdateConfirmationDialog />
      <Table />
    </TableContainer>
  );
};

export default ManageTable;
